import { Outlet, ScrollRestoration } from 'react-router';

const RootLayout = () => (
  <>
    <ScrollRestoration />
    <Outlet />
  </>
);

export default RootLayout;
